import React, { useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setQuestionAnswer, setQuestionAnswerFrench } from "../../../../redux/actions";
import styles from "./PayOwnHeat.module.scss";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";

const PayOwnHeatView = ({ t, i18n }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer("Pay-own-heat", "HARP Application", i18n.language);
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const onNext = (payHeat) => () => {
    try {
      const answer = payHeat ? "Yes" : "No";
      const answerFrench = payHeat ? t("shared.yes") : t("shared.no");
      dispatch(setQuestionAnswer(1, answer));
      dispatch(setQuestionAnswerFrench(1, answerFrench));
      if (payHeat) {
        navigate(`/${i18n.language}${t("routes.sns_letter")}`);
      } else {
        navigate(
          `/${i18n.language}${t("routes.not_eligible")}?question=not_pay_heat`
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(1, ''));
    dispatch(setQuestionAnswerFrench(1, ''));
  }


  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <BackAnchor backPath={"routes.start_page"} onBackClick={handleReduxCleanup} />
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>{t("pay_heat.question")}</h1>
                <p>{t("pay_heat.helper")}</p>
              </div>
            </div>

            {/* Yes/No Answer */}
            <div className="row">
              <div className="col-lg-8">
                <div className="col-xs-2">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default`}
                    onClick={onNext(true)}
                    name={t("shared.yes")}
                  >
                    {t("shared.yes")}
                  </button>
                </div>

                <div className="col-xs-10">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default smallPaddingLeft`}
                    onClick={onNext(false)}
                    value={false}
                    name={t("shared.no")}
                  >
                    {t("shared.no")}
                  </button>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(PayOwnHeatView);
